import { __awaiter } from "tslib";
import { API_HOST } from '@genesislcap/foundation-utils';
import { logger } from './logger';
/**
 * @internal
 */
const getAPIHostHTTPURL = (host = API_HOST, includePath = false) => {
    const url = new URL(host);
    const protocol = url.protocol.replace('ws', 'http');
    const path = includePath ? url.pathname : '';
    return `${protocol}//${url.host}${path}`;
};
/**
 * @internal
 */
const getIPDEndpoint = (path, host) => `${getAPIHostHTTPURL(host)}/${path}`;
/**
 * Get SSO identity provider login URL
 *
 * @public
 */
export const getSSOLoginURL = (idp, path = '/login?idp=', host = API_HOST) => {
    if (!idp || !idp.type || !idp.id) {
        throw new Error(`Invalid IDP: ${JSON.stringify(idp)}`);
    }
    return `${getAPIHostHTTPURL(host, true)}${idp.type}${path}${idp.id}`;
};
/**
 * Request SSO identity provider list
 *
 * @public
 */
export const fetchIDPs = (path = 'sso/list', host = API_HOST) => __awaiter(void 0, void 0, void 0, function* () {
    const IDP_ENDPOINT = getIPDEndpoint(path, host);
    return fetch(IDP_ENDPOINT)
        .then((res) => {
        if (res.ok)
            return res;
        throw new Error(res.statusText);
    })
        .then((res) => res.json())
        .then(({ IDPS = [] }) => IDPS.map((idp) => ({
        id: idp.ID,
        type: idp.TYPE,
    })))
        .catch(() => {
        logger.error('Failed to fetch identity providers.');
        return [{ id: 'error', type: null, description: 'Failed to fetch providers.' }];
    });
});
